import { fetchApi } from 'api/fetchApi'
import { definitions } from 'api/generated/cascade_change'

export const fetchProfileFieldsCompletenessApi = () => {
  return fetchApi<definitions['IncompleteFields']>(
    '/cascade-change/profile-fields/completeness'
  )
}
